<p-dialog appendTo="body" [header]="header" [(visible)]="visible" [modal]="true" [resizable]="false"
  [style]="{'width': '1000px'}" (onHide)="onCancelClicked()">

  <div class="device-filter-selector">
    <p-table [value]="entries" [scrollable]="true" scrollHeight="300px" dataKey="dataKey" [(selection)]="selectedFilters"
      [customSort]="true" [resizableColumns]="true" (sortFunction)="doCustomSort($event)">

      <ng-template pTemplate="header">
        <tr class="table-row">
          @if (max == 1) {
            <th class="uv-table-checkbox"></th>
          }
          @if (max > 1) {
            <th class="uv-table-checkbox">
              <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
            </th>
          }
          @for (col of cols; track col) {
            <th pResizableColumn [pSortableColumn]="col.field">
              {{col.header}}
              <p-sortIcon [field]="col.field"></p-sortIcon>
            </th>
          }
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-rowData>
        <tr class="table-row" [pSelectableRow]="rowData">
          @if (max == 1) {
            <td class="uv-table-checkbox">
              <p-tableRadioButton [value]="rowData"></p-tableRadioButton>
            </td>
          }
          @if (max > 1) {
            <td class="uv-table-checkbox">
              <p-tableCheckbox [value]="rowData"></p-tableCheckbox>
            </td>
          }
          @for (col of cols; track col) {
            <td>
              <span class="uv-table-value">{{rowData[col.field]}}</span>
            </td>
          }
        </tr>
      </ng-template>
    </p-table>

    <p-footer>
      <div class="mb-3"></div>
      <button type="button" pButton icon="fa fa-check" [disabled]="!isOkEnabled()"
      (click)="onOkClicked()" label="OK"></button>
      <button type="button" pButton icon="fa fa-times" [disabled]="false"
      (click)="onCancelClicked()" label="Cancel"></button>
    </p-footer>

  </div>

</p-dialog>
